<template>
    <project-step-container
            prev-to="be_deep_customer_empathy_7"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject"
    >
        <b-row>
            <b-col cols="12" class="main-text " tabindex="0">
             {{getMessage(8, 'empathy-map-sub')}}     
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col cols="12" class="mt-3">
                <label for="first-thing">{{getMessage(8, 'iam')}}</label>
                <input id="first-thing" type="text" v-model="form.iam"  :placeholder="getMessage(8, 'iamplaceholder')"/>
            </b-col>
            <b-col cols="12" class="mt-3">
                <label for="second-thing">{{getMessage(8, 'tryingto')}}</label>
                <input id="second-thing" type="text" v-model="form.tryingto" :placeholder="getMessage(8, 'tryingtoplaceholder')"  />
            </b-col>
            <b-col cols="12" class="mt-3">
                <label for="third-thing">{{getMessage(8, 'but')}}</label>
                <input id="third-thing" type="text" v-model="form.but" :placeholder="getMessage(8, 'butplaceholder')"  />
            </b-col>
            <b-col cols="12" class="mt-3">
                <label for="four-thing">{{getMessage(8, 'because')}}</label>
                <input id="four-thing" type="text" v-model="form.because" :placeholder="getMessage(8, 'becauseplaceholder')"  />
            </b-col>
            <b-col cols="12" class="mt-3">
                <label for="five-thing">{{getMessage(8, 'emotions')}}</label>
                <input id="five-thing" type="text" v-model="form.emotions"  :placeholder="getMessage(8, 'emotionsplaceholder')"/>
            </b-col>
        </b-row>
    </project-step-container>
</template>

<script>
    import Steps from "../Utils/steps";
    import {Storage, Project, ConflictSyn} from "../../../core/Utils"
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"

    export default {
        name: "DeepCustomerEmpathy8",
        components: { ProjectStepContainer },
        data() {
            return {
                step: Steps.FORM_CUSTOMER_PROBLEM,
                urlNextProject:'be_deep_customer_empathy_9',
                form: {
                    iam: "",
                    tryingto: "",
                    but: "" ,
                    because: "" ,
                    emotions: ""
                }
            }
        },
        mounted() {
            const forms = Storage.getProjectForms(this.$route.params.index)
            if (this.step in forms) this.form = forms[this.step];
        },
        methods: {
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index
                Project.saveProjectStep(index, this.step, stepNumber, this.form, this.isOffline, this.isGuest).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection(){
                const index = this.$route.params.index
                this.$router.push({name: this.urlNextProject, params: {index}})
            }
        }
    }
</script>

